import { render, staticRenderFns } from "./preview-edit-content.vue?vue&type=template&id=2440fd0b"
import script from "./preview-edit-content.vue?vue&type=script&lang=js"
export * from "./preview-edit-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports